import { AfterViewInit, ChangeDetectorRef, Directive, HostBinding, OnDestroy } from "@angular/core";
import { LoadingContentService } from '../services/loading-content.service';

@Directive({
    selector: '[loading]'
})
export class LoadingDirective implements AfterViewInit, OnDestroy {
    // @Input() loading: string;
    @HostBinding('class.loading') isLoading = false;

    constructor(
        private loadingService: LoadingContentService,
        private cdRef: ChangeDetectorRef
    ) {

    }

    ngAfterViewInit() {
        this.loadingService.loading.subscribe(value => {
            this.isLoading = value;
            // tslint:disable-next-line:no-string-literal
            if (!this.cdRef['destroyed']) {
                this.cdRef.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        this.cdRef.detach();
    }

}
